import React from 'react';
import { useTranslation } from 'react-i18next';
import { RegCodeInput } from '../regCodeInput/RegCodeInput';
import { LoadingSpinner } from 'ui/shared/LoadingSpinner';
import { ErrorMessage } from 'ui/shared/messages';
import { useSetup } from 'hooks/useSetup/useSetup';

require('./SetupRegCodePanel.css');

export const SetupRegCodePanel = () => {
    const { t } = useTranslation();

    const {
        regCode,
        busy,
        errorMessage,
        changeRegCode,
    } = useSetup();

    return (
        <div id="setup-reg-code-panel" className="setup-panel">
            <h2>
                { t('SETUP.REG_CODE') }
            </h2>
            <p>
                { t('SETUP.REG_CODE_DESC') }
            </p>
            <div>
                <RegCodeInput
                    value={ regCode }
                    onChange={ changeRegCode }
                    disabled={ busy }
                />
                { busy &&
                    <LoadingSpinner size="small"/>
                }
            </div>
            <ErrorMessage message={ errorMessage }/>
        </div>
    );
};
